var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeam = function SvgTeam(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7259 30.6645C38.2967 28.5009 34.3705 27.3138 30.313 27.0918C31.2511 27.5309 32.1796 27.9947 33.0601 28.5503C35.1817 29.8869 36.5001 32.3076 36.5001 34.8661V41.9999H44V34.8661C44 33.1596 43.1285 31.5495 41.7259 30.6645Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7257 30.6645C24.1257 25.8696 13.873 25.8696 6.27536 30.6645C4.8716 31.5483 4 33.1584 4 34.8662V41.9999H33.9999V34.8662C33.9999 33.1584 33.1283 31.5483 31.7257 30.6645Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4856 24.0859C27.2937 24.3305 28.1277 24.5 29.0001 24.5C33.8243 24.5 37.75 20.5743 37.75 15.7501C37.75 10.9258 33.8243 7 29.0001 7C28.1277 7 27.2937 7.16953 26.4856 7.41415C28.7785 9.47499 30.2501 12.4312 30.2501 15.75C30.2501 19.0687 28.7786 22.025 26.4856 24.0859Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1871 9.5628C28.6043 12.9799 28.6043 18.52 25.1871 21.9371C21.77 25.3542 16.2299 25.3542 12.8128 21.9371C9.39572 18.52 9.39572 12.9799 12.8128 9.5628C16.2299 6.14569 21.77 6.14577 25.1871 9.5628Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.313,
    y1: 27.0918,
    x2: 43.1203,
    y2: 26.3709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4,
    y1: 27.0684,
    x2: 31.7397,
    y2: 23.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 26.4856,
    y1: 7,
    x2: 37.043,
    y2: 6.58337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.25,
    y1: 7,
    x2: 26.6156,
    y2: 5.99664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/team.115773a3d4d92f26b7ff364c1986dbfb.svg";